/**
 * Toast helper for API `email_dispatch` payloads.
 *
 * Callers must not hardcode template names. The backend supplies a generic
 * `message` for skipped/failed sends (inactive template, missing template, etc.).
 */
import { toast } from 'sonner';

export function toastEmailDispatch(email, { sentMessage } = {}) {
  if (!email || email.status === 'sent') {
    if (sentMessage) toast.success(sentMessage);
    return;
  }
  toast.warning(
    email.message
      || 'Email was not sent because the email template is inactive.',
  );
}
